import { Component, Input, ChangeDetectionStrategy, OnInit } from '@angular/core'
import { BasePostForm } from './base-post-form.component'
import { Post, Customer } from 'src/modules/submissions/submission.queries'
import { PostBoxMutations } from '../post-box.mutations'
import { successToast, errorToast } from 'src/toaster'
import { FormBuilder, FormGroup } from '@angular/forms'

@Component({
  selector: 'post-wl-review-form',
  styles: [`
    label {
      font-weight: normal;
    }
  `],
  template: `
    <h4>{{title}}</h4>
    <p>{{subtitle}}</p>
    <rating-stars *ngIf="hasBeenReviewed" [value]="post.wlRating?.value" [disabled]="true"></rating-stars>
    <div *ngIf="!hasBeenReviewed">
      <h4>Leave a review</h4>
      <form [formGroup]="form">
        <textarea
          formControlName="content"
          rows="2"
          id="wl-review-post-{{post?.id}}"
          class="form-control textarea-mobile"
          name="content"
          placeholder="{{placeholder}}">
        </textarea>
        <div class="mt-3">
          <rating-stars [value]="form.value.stars" (onChange)="onRatingChange($event)"></rating-stars>
        </div>
        <div class="mt-3">
          <button class="btn btn-primary" (click)="onSubmit()" [disabled]="!readyToSubmit()">{{title}}</button>
        </div>
      </form>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PostWlReviewForm extends BasePostForm implements OnInit {
  @Input() post: Post
  @Input() customer: Customer
  @Input() action: 'approve' | 'reject'
  wlPostReview: Post['wlPostReview']
  content: string = ''
  hasBeenReviewed = false

  form: FormGroup

  title: string
  subtitle: string
  placeholder: string

  saving: boolean = false

  constructor(
    private mutations: PostBoxMutations,
    private fb: FormBuilder) {
    super()
  }

  ngOnInit(): void {
    this.hasBeenReviewed = !!this.post.wlPostReview
    if (this.hasBeenReviewed) {
      this.title = `You ${this.post.wlPostReview.action === 'approve' ? 'approved' : 'rejected'} this piece`
      this.subtitle = this.post.wlPostReview.content
    } else {
        if (this.action == 'approve') {
        this.title = "Approve"
        this.subtitle = "We’re so glad you like this piece!"
        this.placeholder = "Please let us know what you like so we can keep up the good work."
      } else {
        this.title = "Reject"
        this.subtitle = "We’re sorry to hear this piece didn’t  work out.  Please let us know what you wish was different, so that we can improve for next time. "
        this.placeholder = "What do you wish was different? What do you like?"
      }
    }
    this.resetForm()
  }

  resetForm(): void {
    this.form = this.fb.group({
      content: '',
      stars: 0 //should this be null?
    })
  }

  onRatingChange(newValue: number): void {
    this.form.patchValue({ stars: newValue })
  }

  readyToSubmit(): boolean {
    return this.form.valid && !this.saving
  }

  onSubmit(): void {
    this.mutations.wlReviewPost({
      post: this.post,
      content: this.form.value.content,
      stars: this.form.value.stars,
      action: this.action
    }).then((res) => {
      if (res.data?.WlReviewPost?.errors?.length > 0) {
        res.data.WlReviewPost.errors.forEach(error => errorToast(error))
      } else if ( res.data?.WlReviewPost?.post ) {
        const toastMessage = this.action === 'approve' ? 'You’ve approved this piece! We’ll finalize and deliver it to you shortly.' : 'You’ve rejected this piece. We’ll get you a new one as soon as we can.'
        successToast(toastMessage)
      }
    })
  }
}
